// extracted by mini-css-extract-plugin
export default {"list":"ListOfSmartFilters-module__list--b69d0","maxSelectedLabel":"ListOfSmartFilters-module__maxSelectedLabel--ac95c"};